/* Sauber – Productos que te podrían interesar (venta cruzada por categoría) */
(function () {
  'use strict';
  var CFG = window.SauberComp || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};

  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount_no_decimals}}';
    var n = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, fmt.indexOf('comma_separator') > -1 ? '.' : ',');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  function fetchCollection(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(ROOT + 'collections/' + handle + '/products.json?limit=24')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return (j.products || []).filter(function (p) { return p.variants.some(function (v) { return v.available; }); }); })
        .catch(function () { return []; });
    }
    return cache[handle];
  }

  function card(p) {
    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    var price = Math.round(parseFloat(v.price) * 100);
    var compare = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
    var src = p.images && p.images[0] ? p.images[0].src : '';
    var url = ROOT + 'products/' + p.handle;
    var d = compare > price ? Math.round((1 - price / compare) * 100) : 0;
    return '<div class="sb-card">' +
      '<a class="sb-card__media" href="' + esc(url) + '" tabindex="-1">' +
        (src ? '<img src="' + esc(img(src, 400)) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400">' : '') +
        (d > 0 ? '<span class="sb-card__badge">-' + d + '%</span>' : '') +
      '</a>' +
      '<div class="sb-card__body">' +
        '<a class="sb-card__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
        '<div class="sb-price"><span class="sb-now">' + money(price) + '</span>' + (d > 0 ? '<span class="sb-was">' + money(compare) + '</span>' : '') + '</div>' +
        '<a class="sb-btn sb-btn--ghost" href="' + esc(url) + '">Ver producto</a>' +
      '</div></div>';
  }

  var NAV = '<div class="sb-nav">' +
    '<button type="button" data-sbx-nav="prev" aria-label="Anterior"><svg viewBox="0 0 20 20" width="16" height="16"><path d="M12.5 4.5 7 10l5.5 5.5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
    '<button type="button" data-sbx-nav="next" aria-label="Siguiente"><svg viewBox="0 0 20 20" width="16" height="16"><path d="M7.5 4.5 13 10l-5.5 5.5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>';

  function updateNav(box) {
    var t = box.querySelector('.sb-comp__track'), prev = box.querySelector('[data-sbx-nav="prev"]'), next = box.querySelector('[data-sbx-nav="next"]');
    if (!t || !prev) return;
    var max = t.scrollWidth - t.clientWidth - 2;
    box.classList.toggle('sb-scrollable', max > 0);
    prev.disabled = t.scrollLeft <= 2;
    next.disabled = t.scrollLeft >= max;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sbx-nav]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('.sb-xsell'), t = box.querySelector('.sb-comp__track'), c = t.querySelector('.sb-card');
    var step = c ? c.getBoundingClientRect().width + 12 : t.clientWidth * 0.8;
    t.scrollBy({ left: b.getAttribute('data-sbx-nav') === 'next' ? step : -step, behavior: 'smooth' });
  });

  function render(box) {
    if (box.getAttribute('data-sb-ready')) return;
    box.setAttribute('data-sb-ready', '1');
    var handles = (box.getAttribute('data-handles') || '').split(',');
    var type = 'type:' + (box.getAttribute('data-type') || '').trim().toLowerCase();
    var rules = CFG.xsell || [], rule = null;
    for (var i = 0; i < rules.length && !rule; i++) {
      var key = String(rules[i][0]).toLowerCase();
      if (key === type || handles.indexOf(rules[i][0]) > -1) rule = rules[i];
    }
    if (!rule && CFG.xsellDefault) rule = CFG.xsellDefault;
    if (!rule) { box.remove(); return; }
    var pid = String(box.getAttribute('data-product-id'));
    Promise.all(rule[1].map(fetchCollection)).then(function (lists) {
      var seen = {}, out = [], max = Number(CFG.xsellLimit) || 8;
      seen[pid] = true;
      for (var k = 0; out.length < max; k++) {
        var any = false;
        lists.forEach(function (list) {
          var p = list[k];
          if (p) any = true;
          if (p && !seen[p.id] && out.length < max) { seen[p.id] = true; out.push(p); }
        });
        if (!any) break;
      }
      if (!out.length) { box.remove(); return; }
      box.innerHTML =
        '<div class="sb-comp__head"><div><h2 class="sb-comp__title">' + esc(CFG.xsellHeading || 'Productos que te podrían interesar') + '</h2>' +
        (rule[2] ? '<p class="sb-comp__sub">' + esc(rule[2]) + '</p>' : '') + '</div>' + NAV + '</div>' +
        '<div class="sb-comp__track">' + out.map(card).join('') + '</div>';
      box.classList.add('is-ready');
      var t = box.querySelector('.sb-comp__track');
      t.addEventListener('scroll', function () { updateNav(box); }, { passive: true });
      window.addEventListener('resize', function () { updateNav(box); });
      updateNav(box);
      setTimeout(function () { updateNav(box); }, 400);
    });
  }

  function init() { document.querySelectorAll('.sb-xsell[data-handles]').forEach(render); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
